import Component from '../abstracts/Component';

export default class PerfectFitComponent extends Component {

  get SELECTORS() {
    return {
      main: '.c-perfect-fit',
      wrapperCarousel: '.wrapper-carousel .carousel',
      pairings: '.wrapper-pairing',
      imageCarousel: '.image-carousel',
      imagePreview: '.image-preview'
    }
  }

  constructor() {
    super()

    this.main = $(this.SELECTORS.main);
    this.imgCarousel = $(this.SELECTORS.imageCarousel);
    this.hoverTimeout = null;
    this.clickTimeout = null;
    this.previousSlide = null;
    this.clickable = false;
    this.clicked = false;
  }

  handlePair($el, carousels, carouselIndex, currentSlide, type) {
    let pairing = this.findPairing(carousels, carouselIndex, currentSlide);

    if (pairing.length > 0) {
      this.log('found pairing');
      this.clickable = true;
      clearTimeout(this.hoverTimeout);

      let cloned = this.imgCarousel.find('.cloned');
      //is cloned different from previous image
      if (cloned.length == 0 ||
        cloned.find('img').attr('src') != pairing.data('image')) {

        this.log('different from previous one');

        this.imgCarousel.removeClass('clicked');

        this.imgCarousel.find('picture.cloned').remove();

        const picture = this.imgCarousel.find('picture');
        picture.clone().addClass('cloned').prependTo(this.imgCarousel);
        cloned = this.imgCarousel.find('.cloned');

        // modifico gli attributi dell'immagine
        cloned.find('img').attr('src', pairing.data('image'));
        cloned.find('img').css('top', 0);
        cloned.find('source').attr('srcset', pairing.data('imageSmall'));
        this.main.find('.button-primary').attr('href', pairing.data('link'));

        this.imgCarousel.addClass('duplicated');
      } else {
        this.log("pairing not found");
        $el.stop();
      }

      // update images for image preview
      if (type == "click") {
        const $imagePreview = $el.find(this.SELECTORS.imagePreview);
        $imagePreview.fadeOut(300, () => {
          $imagePreview.find('img').attr('src', pairing.data('image'));
          $imagePreview.find('source').attr('srcset', pairing.data('imageSmall'));
          this.updateImagePreview($imagePreview, $el);
          $imagePreview.fadeIn(300);
        });
      }

      this.hoverTimeout = setTimeout(() => {
        switch (type) {
          case "hover":
            this.imgCarousel.addClass('animate');
            this.imgCarousel.addClass('hovered');
            currentSlide.addClass('hovered');
            break;

          case "click":
            this.imgCarousel.addClass('clicked');
            this.clickTimeout = setTimeout(() => {
              this.imgCarousel.find('picture:not(.cloned)').remove();
              this.imgCarousel.find('picture.cloned').removeClass('cloned');
              this.imgCarousel.removeClass('duplicated');
              this.imgCarousel.removeClass("clicked");
              this.clicked = false;
            }, 550);
            break;

          default:
            break;
        }
      }, 50);

    } else {
      this.warn("pairing not found");
      $el.stop();
    }

    if (type == 'click') {
      setTimeout(() => {
        this.toggleOtherSlider(carousels, carouselIndex, true)
      }, 800);
    }
  }

  updateImagePreview($imagePreview, $el) {
    const startImage = $el.find(`${this.SELECTORS.imageCarousel} > picture img`);
    const percentHeight = ($el.height() * 100) / startImage.height();
    const visible = $imagePreview.find('.section-visible');
    visible.css('top', 0);
    if (percentHeight > 99) {
      visible.css('height', '100%');
    } else {
      visible.css('height', `${percentHeight}%`);
    }
  }

  findPairing(carousels, carouselIndex, currentSlide) {
    let pairing = undefined;

    switch (carouselIndex) {
      case 0:
        pairing = $(this.SELECTORS.pairings).find(`[data-text-style="${currentSlide.text()}"][data-text-occasion="${$(carousels[1]).find('.slick-current').text()}"]`);
        break;
      case 1:
        pairing = $(this.SELECTORS.pairings).find(`[data-text-occasion="${currentSlide.text()}"][data-text-style="${$(carousels[0]).find('.slick-current').text()}"]`);
        break;

      default:
        break;
    }

    return pairing;
  }

  checkPairing(carousels, carouselIndex, currentSlide) {

    if (typeof currentSlide === 'undefined' || currentSlide == null) {
      return false;
    }

    let pairing = this.findPairing(carousels, carouselIndex, currentSlide);

    let cloned = this.imgCarousel.find('.cloned');

    return ((cloned.length == 0) ||
      ((cloned.find('img').attr('src') != pairing.data('image')) &&
        (cloned.find('source').attr('srcset') != pairing.data('imageSmall')) &&
        (this.main.find('.button-primary').attr('href') != pairing.data('link'))));
  }

  toggleOtherSlider(carousels, carouselIndex, enable) {
    carousels.each((index, el) => {
      if (index != carouselIndex) {
        $(el).find('.slick-arrow').each((i, slide) => {
          if (enable == true) {
            $(slide).removeAttr('disabled');
            $(slide).css('pointer-events', 'auto')
          } else {
            $(slide).attr('disabled', 'disabled');
            $(slide).css('pointer-events', 'none');
          }
        });
      }
    });
  }

  toggleHover(carousels, enable) {
    carousels.each((index, el) => {
      $(el).find('.slick-slide').each((i, slide) => {
        if (enable == true) {
          $(slide).css('pointer-events', 'auto');
          this.clicked = false;
        } else {
          $(slide).css('pointer-events', 'none');
        }
      });
    });
  }

  bindEvents(el) {

    const $el = $(el),
      _this = this,
      $imagePreview = $el.find(this.SELECTORS.imagePreview);

    this.updateImagePreview($imagePreview, $el);

    $imagePreview.find('img').on('click', (e) => {
      console.log('click image preview');
      const prewVisible = $imagePreview.find('.section-visible');
      const imgVisible = $el.find(`${_this.SELECTORS.imageCarousel} > picture img`);
      let top = null;
      // for background image black line
      let isBottom = false;
      if (e.offsetY <= prewVisible.height() / 2) {
        top = 0;
      } else if (e.offsetY > ($imagePreview.height() - (prewVisible.height() / 2))) {
        top = $imagePreview.height() - prewVisible.height() - 1;
        isBottom = true;
      } else {
        top = e.offsetY - (prewVisible.height() / 2);
      }

      prewVisible.css('top', top);

      let topImage = (imgVisible.height() * top) / $imagePreview.height();
      if (isBottom) {
        imgVisible.css('top', -(imgVisible.height() - $el.height()))
      } else {
        imgVisible.css('top', -topImage)
      }

    });

    const carousels = $el.find(this.SELECTORS.wrapperCarousel);

    carousels.each((index, element) => {
      $(element).on("init", () => {

        const $slides = $(element).find('.slick-slide');

        // mouseover on previous slide
        $slides.on("mouseover", (e) => {
          // controllo che la slide in hover sia quella precedente all'attiva
          if ($(e.currentTarget).is($(element).find('.slick-current').prev()) && !_this.clicked) {
            _this.log(`hover ${index == 1 ? "occasion" : "style"} slide`);
            _this.handlePair($el, carousels, index, $(e.currentTarget), "hover");
          }
        });

        // mouseleave on previous slide
        $slides.on("mouseleave", (e) => {
          if ($(e.currentTarget).is($(element).find('.slick-current').prev()) && !_this.clicked) {
            clearTimeout(_this.hoverTimeout);
            _this.clickable = false;
            _this.imgCarousel.removeClass("hovered");
            $(e.currentTarget).removeClass("hovered");
            _this.hoverTimeout = setTimeout(() => {
              _this.imgCarousel.removeClass("animate");
              _this.imgCarousel.removeClass("duplicated");
              _this.imgCarousel.find("picture.cloned").remove();
            }, 300);
          }
        });

        // click on previous slide
        $slides.on("click", (e) => {
          if ($(e.currentTarget).is($(element).find('.slick-current').prev()) && _this.clickable && $(e.currentTarget).hasClass('hovered')) {
            _this.clickable = false;
            _this.toggleHover(carousels, false);
            _this.imgCarousel.addClass("clicked");
            $(e.currentTarget).removeClass("hovered");

            // avanzo il carosello
            $(element).slick('slickPrev');

            _this.hoverTimeout = setTimeout(() => {
              _this.imgCarousel.removeClass("animate hovered");
              _this.imgCarousel.find('picture:not(.cloned)').remove();
              _this.imgCarousel.find('picture.cloned').removeClass('cloned');
              _this.imgCarousel.removeClass('duplicated');
              _this.imgCarousel.removeClass("clicked");
            }, 600);

            let src = _this.imgCarousel.find('picture img').attr('src'),
              srcset = _this.imgCarousel.find('picture source').attr('srcset');

            // update images for image preview
            const $imagePreview = $el.find(this.SELECTORS.imagePreview);
            $imagePreview.fadeOut(300, () => {
              $imagePreview.find('img').attr('src', src);
              $imagePreview.find('source').attr('srcset', srcset);
              this.updateImagePreview($imagePreview, $el);
              $imagePreview.fadeIn(300);
            });

            setTimeout(() => {
              _this.toggleHover(carousels, true);
            }, 650);
          }
        });

        // handle mousedown on prev arrow
        $(element).find('.slick-prev').on('mousedown', (e) => {
          _this.toggleOtherSlider(carousels, index, false);
          if (_this.previousSlide == null || _this.checkPairing(carousels, index, _this.previousSlide)) {
            _this.log("click arrow");
            _this.previousSlide = $(element).find('.slick-current').prev();
          }
        });

        //handle before change slide on arrow click
        $(element).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          if (_this.checkPairing(carousels, index, _this.previousSlide)) {
            _this.log('beforechange ho cliccato next');
            _this.clicked = true;
            _this.handlePair($el, carousels, index, _this.previousSlide, "click");
          } else {
            setTimeout(() => {
              _this.toggleOtherSlider(carousels, index, true)
            }, 600);
          }
          _this.previousSlide = null;
        });
      })
    });
  }

  render() {

    if ($(document.body).hasClass('editmode')) return;

    if (this.main.length > 0) {
      this.log('binding events for perfect fit component');
      this.main.each((index, element) => {
        this.bindEvents(element);
      });
    }
  }
}
